import * as yup from "yup";

export const validationSchema = yup.object().shape({
    propertyType: yup
        .string()
        .notOneOf([""], "form.estimation.error.required")
        .required("form.estimation.error.required"),
    firstName: yup.string().required("form.estimation.error.required"),
    lastName: yup.string().required("form.estimation.error.required"),
    email: yup
        .string()
        .email("form.estimation.error.invalid-email")
        .required("form.estimation.error.required"),
    phoneNumber: yup
        .string()
        .matches(/^[0-9\s\-+]*$/, "form.estimation.error.invalid-phone")
        .min(9, "form.estimation.error.invalid-phone")
        .max(15, "form.estimation.error.invalid-phone")
        .required("form.estimation.error.required"),
    postalCode: yup
        .string()
        .matches(/^\d*$/, "form.estimation.error.invalid-postal-code")
        .min(4, "form.estimation.error.invalid-postal-code")
        .max(4, "form.estimation.error.invalid-postal-code")
        .required("form.estimation.error.required"),
    street: yup.string().required("form.estimation.error.required"),
    number: yup.string().required("form.estimation.error.required"),
    city: yup.string().required("form.estimation.error.required"),
    gdpr: yup.boolean().oneOf([true], "form.estimation.error.accept-terms"),
    submitError: yup.string(),
});
